import { render, staticRenderFns } from "./index.vue?vue&type=template&id=31415bac&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31415bac')) {
      api.createRecord('31415bac', component.options)
    } else {
      api.reload('31415bac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=31415bac&", function () {
      api.rerender('31415bac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/Charts/Layouts/ReportSection/index.vue"
export default component.exports